import { render, staticRenderFns } from "./NewListingDetails.vue?vue&type=template&id=5b0a938c&scoped=true&"
import script from "./NewListingDetails.vue?vue&type=script&lang=js&"
export * from "./NewListingDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewListingDetails.vue?vue&type=style&index=0&id=5b0a938c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a938c",
  null
  
)

export default component.exports